<template>
  <div class="course-list">
    <div class="version-select">
      <!-- 选择学科 -->
      <ul class="subject-ul">
        <li
          v-for="(subject, index) in subjectList"
          :key="index"
          :class="[subject['active'] ? 'is-active' : '']"
          @click="choiseSubject(subject, index)"
        >
          <span>{{ subject.subject_name }}</span>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <!-- 选择年级 -->
      <ul class="grade-ul">
        <li
          v-for="(grade, index) in gradeList"
          :key="index"
          :class="[grade['active'] ? 'is-active' : '']"
          @click="choiseGrade(grade, index)"
        >
          <span>{{ grade.grade_name }}{{ grade.term_name }}</span>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <!-- 选择版本 -->
      <ul class="text-book-ul">
        <li
          v-for="(textBook, index) in textBookList"
          :key="index"
          :class="[textBook['active'] ? 'is-active' : '']"
          @click="choiseTextBook(textBook, index)"
        >
          <span>{{ textBook.textbook_name }}</span>
          <i class="el-icon-check" v-show="textBook['active']"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getCmsSubjectList, getSGVList, getClassSubjectList, getClassSGVList,
} from '@/api/pt';

export default {
  name: 'ChoiseCategory',
  props: {
    fromType: {
      type: String,
      default: '',
    },
    classId: {
      type: String,
    },
    type: {},
  },
  data() {
    const { subjectId } = this.$route.query;
    return {
      subjectId,
      subjectList: [],
      gradeList: [],
      textBookList: [],
      currentSubject: {},
      currentGrade: {},
      currentTextBook: {},
    };
  },
  computed: {
    ...mapGetters([
      'categoryObj',
    ]),
  },
  methods: {
    async getCmsSubjectList() {
      const hwType = Number(this.fromType) === 3 ? 3 : 4;
      let res;
      if (this.type) {
        res = await getClassSubjectList({
          hw_type: hwType,
          class_id: this.classId,
        });
      } else {
        res = await getCmsSubjectList({
          hw_type: hwType,
          class_id: this.classId,
        });
      }
      if (res.code === 200) {
        this.subjectList = res.data;
        if (this.categoryObj.subjectId !== '') {
          const selectSubjectId = this.categoryObj.subjectId;
          this.currentGrade.grade_id = this.categoryObj.gradeId;
          this.currentGrade.grade_name = this.categoryObj.gradeName;
          this.currentGrade.term_id = this.categoryObj.termId;
          this.currentGrade.term_name = this.categoryObj.termName;
          this.currentTextBook.textbook_id = this.categoryObj.textbookId;
          this.currentTextBook.textbook_name = this.categoryObj.textbookName;

          this.subjectList.forEach((item) => {
            if (String(item.subject_id) === String(selectSubjectId)) {
              this.$set(item, 'active', true);
              this.currentSubject.subjectId = item.subject_id;
              this.currentSubject.subjectName = item.subject_name;
              this.querySGVList();
            } else {
              this.$set(item, 'active', false);
            }
          });
        }
      }
    },
    async querySGVList() {
      let res;
      if (this.type) {
        res = await getClassSGVList({
          subject_id: this.currentSubject.subjectId,
          hw_type: 3,
          class_id: this.classId,
        });
      } else {
        res = await getSGVList({
          subject_id: this.currentSubject.subjectId,
          hw_type: 3,
        });
      }
      if (res.code === 200) {
        const { grade } = res.data;
        this.gradeList = [];
        this.textBookList = [];
        grade.forEach((item) => {
          if ((String(item.grade_id) === String(this.categoryObj.gradeId))
            && (String(item.term_id) === String(this.categoryObj.termId))) {
            this.gradeList.push({
              grade_id: item.grade_id,
              grade_name: item.grade_name,
              textbook: item.textbook,
              term_id: item.term_id,
              term_name: item.term_name,
              active: true,
            });
            this.textBookList = item.textbook;
          } else {
            this.gradeList.push({
              grade_id: item.grade_id,
              grade_name: item.grade_name,
              textbook: item.textbook,
              term_id: item.term_id,
              term_name: item.term_name,
              active: false,
            });
          }
          this.textBookList.forEach((tItem) => {
            if (String(tItem.textbook_id) === String(this.categoryObj.textbookId)) {
              this.$set(tItem, 'active', true);
            } else {
              this.$set(tItem, 'active', false);
            }
          });
        });
      }
    },
    // 切换学科
    async choiseSubject(selectItem, selectIndex) {
      this.subjectList.forEach((item, index) => {
        if (selectIndex === index) {
          this.$set(item, 'active', true);
        } else {
          this.$set(item, 'active', false);
        }
      });
      this.currentSubject.subjectId = selectItem.subject_id;
      this.currentSubject.subjectName = selectItem.subject_name;
      let res;
      if (this.type) {
        await getClassSGVList({
          subject_id: this.currentSubject.subjectId,
          hw_type: 3,
          class_id: this.classId,
        }).then((data) => {
          if (data.code === 200) {
            res = data.data;
          }
        });
      } else {
        await getSGVList({
          subject_id: this.currentSubject.subjectId,
          hw_type: 3,
        }).then((data) => {
          if (data.code === 200) {
            res = data.data;
          }
        });
      }
      const { grade } = res;
      const gradeArr = grade;
      this.gradeList = [];
      this.textBookList = [];
      gradeArr.forEach((item, index) => {
        if (index === 0) {
          this.gradeList.push({
            grade_id: item.grade_id,
            grade_name: item.grade_name,
            textbook: item.textbook,
            term_id: item.term_id,
            term_name: item.term_name,
            active: true,
          });
          this.currentGrade.grade_id = item.grade_id;
          this.currentGrade.grade_name = item.grade_name;
          this.currentGrade.term_id = item.term_id;
          this.currentGrade.term_name = item.term_name;
          this.textBookList = item.textbook;
        } else {
          this.gradeList.push({
            grade_id: item.grade_id,
            grade_name: item.grade_name,
            textbook: item.textbook,
            term_id: item.term_id,
            term_name: item.term_name,
            active: false,
          });
        }
      });
      this.textBookList.forEach((item) => {
        this.$set(item, 'active', false);
      });
    },
    // 选择年级
    choiseGrade(selectItem, selectIndex) {
      this.gradeList.forEach((item, index) => {
        const newItem = item;
        if (selectIndex === index) {
          newItem.active = true;
          this.textBookList = item.textbook;
          if (this.textBookList.length === 1) {
            const firstTextBook = this.textBookList[0];
            firstTextBook.active = true;
            this.$set(this.textBookList, 0, firstTextBook);
            this.currentTextBook.textbook_id = firstTextBook.textbook_id;
            this.currentTextBook.textbook_name = firstTextBook.textbook_name;
          }
        } else {
          newItem.active = false;
        }
        this.$set(this.gradeList, index, newItem);
        this.currentGrade.grade_id = selectItem.grade_id;
        this.currentGrade.grade_name = selectItem.grade_name;
        this.currentGrade.term_id = selectItem.term_id;
        this.currentGrade.term_name = selectItem.term_name;
      });
    },
    // 选择版本
    choiseTextBook(selectItem, selectIndex) {
      this.textBookList.forEach((item, index) => {
        const newItem = item;
        if (selectIndex === index) {
          newItem.active = true;
        } else {
          newItem.active = false;
        }
        this.$set(this.textBookList, index, newItem);
      });
      this.currentTextBook.textbook_id = selectItem.textbook_id;
      this.currentTextBook.textbook_name = selectItem.textbook_name;
      this.$store.commit('CHOOSE_KNOWLEDGE', []);
      this.$store.commit('SELECT_TAG_ARRAY', []);
      this.hideSubjectGradeText();
    },
    hideSubjectGradeText() {
      let isNeedQuery = false;
      let subjectCheckNum = 0;
      let gradeCheckeNum = 0;
      let textbookCheckNum = 0;

      this.subjectList.forEach((item) => {
        if (item.active) {
          subjectCheckNum += 1;
        }
      });

      this.gradeList.forEach((item) => {
        if (item.active) {
          gradeCheckeNum += 1;
        }
      });

      this.textBookList.forEach((item) => {
        if (item.active) {
          textbookCheckNum += 1;
        }
      });
      if (this.currentTextBook.textbook_name !== '') {
        const cateGoryObj = {
          subjectId: this.currentSubject.subjectId,
          subjectName: this.currentSubject.subjectName,
          gradeId: this.currentGrade.grade_id,
          gradeName: this.currentGrade.grade_name,
          termId: this.currentGrade.term_id,
          termName: this.currentGrade.term_name,
          textbookId: this.currentTextBook.textbook_id,
          textbookName: this.currentTextBook.textbook_name,
        };
        // 判断是否要重新查询数据
        if ((subjectCheckNum > 0 && gradeCheckeNum > 0 && textbookCheckNum > 0)
        // && (this.currentSubject.subjectId !== this.categoryObj.subjectId
        //   || this.currentGrade.grade_id !== this.categoryObj.gradeId
        //   || this.currentTextBook.textbook_id !== this.categoryObj.textbookId
        //   || this.currentGrade.term_name !== this.categoryObj.termName)
        ) {
          isNeedQuery = true;
          if (this.type === 'CommonWrong') {
            localStorage.setItem(`category-last_${this.classId}`, JSON.stringify(cateGoryObj));
            this.$store.commit('SET_COMMON_WRONG_CATEGORY_OBJ', cateGoryObj);
          }
          if (this.type === 'CommonWeak') {
            localStorage.setItem(`commonWeak-last_${this.classId}`, JSON.stringify(cateGoryObj));
            this.$store.commit('SET_COMMON_WEAK_CATEGORY_OBJ', cateGoryObj);
          } else {
            this.$store.commit('SET_CATEGORY_OBJ', cateGoryObj);
          }
          this.$store.commit('CLEAR_QUESTIONS_BASKET', []);
          this.$store.commit('SELECT_TAG_ARRAY', []);
        }
      }
      this.$emit('hideSubjectGradeText', isNeedQuery);
    },
  },
  mounted() {
    this.getCmsSubjectList();
  },
};
</script>
<style lang="scss">
.course-list {
  margin: 5px 0;
  font-size: 14px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 888;
  font-weight: 700;
  .is-active {
    color: #409eff;
  }
  .version-select {
    display: flex;
    justify-content: flex-start;
    // position: relative;
    ul {
      // margin-left: 20px;
      min-width: 180px;
      min-height: 160px;
      box-sizing: border-box;
      color: #606266;
      background: #fff;
      border-right: 1px solid #e4e7ed;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 10px;
        margin: 10px 0;
        cursor: pointer;
      }
    }
    .text-book-ul {
      border-right: none;
      li {
        justify-content: flex-start;
        span {
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
